import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || 'YOUR_MIXPANEL_TOKEN_HERE';

class MixpanelService {
  constructor() {
    this.isInitialized = false;
    this.init();
  }

  init() {
    if (MIXPANEL_TOKEN && MIXPANEL_TOKEN !== 'YOUR_MIXPANEL_TOKEN_HERE') {
      mixpanel.init(MIXPANEL_TOKEN, {
        debug: process.env.NODE_ENV === 'development',
        track_pageview: false,
        persistence: 'localStorage'
      });
      this.isInitialized = true;
    } else {
      console.warn('Mixpanel token not found. Analytics will not be tracked.');
    }
  }

  track(eventName, properties = {}) {
    if (!this.isInitialized) return;
    
    mixpanel.track(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      user_agent: navigator.userAgent
    });
  }

  identify(userId) {
    if (!this.isInitialized) return;
    mixpanel.identify(userId);
  }

  setUserProperties(properties) {
    if (!this.isInitialized) return;
    mixpanel.people.set(properties);
  }

  trackPageView(pageName, properties = {}) {
    this.track('Page View', {
      page_name: pageName,
      path: window.location.pathname,
      ...properties
    });
  }

  trackAuth(action, method = 'email') {
    this.track(`Auth ${action}`, {
      method,
      timestamp: new Date().toISOString()
    });
  }

  trackFunnelStep(step, properties = {}) {
    const funnelSteps = {
      'signup': 'Funnel: Signup',
      'create_pool': 'Funnel: Create Pool', 
      'add_measurement': 'Funnel: Add Measurement'
    };

    this.track(funnelSteps[step] || `Funnel: ${step}`, {
      funnel_step: step,
      ...properties
    });
  }

  trackPoolAction(action, poolData = {}) {
    this.track(`Pool ${action}`, {
      pool_id: poolData.id,
      pool_type: poolData.type,
      ...poolData
    });
  }

  trackMeasurement(action, measurementData = {}) {
    this.track(`Measurement ${action}`, {
      measurement_id: measurementData.id,
      parameters_count: measurementData.parameters_count,
      ...measurementData
    });
  }
}

const mixpanelService = new MixpanelService();
export default mixpanelService;